module.exports = __webpack_public_path__ + "img/thailandflag.62cbd2d5.svg";